// Cart drawer functionality
document.addEventListener("DOMContentLoaded", () => {
  const cartButton = document.getElementById("cart-button")
  const cartDrawer = document.getElementById("cart-drawer")
  const closeCart = document.getElementById("close-cart")
  const overlay = document.getElementById("cart-overlay") || document.getElementById("overlay")

  if (cartButton && cartDrawer && closeCart && overlay) {
    cartButton.addEventListener("click", (e) => {
      e.preventDefault()
      cartDrawer.classList.remove("translate-x-full")
      overlay.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    })

    closeCart.addEventListener("click", () => {
      cartDrawer.classList.add("translate-x-full")
      overlay.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    })

    overlay.addEventListener("click", () => {
      cartDrawer.classList.add("translate-x-full")
      overlay.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    })
  }

  // Quantity selectors
  const quantityInputs = document.querySelectorAll('input[type="number"]')
  quantityInputs.forEach((input) => {
    const minusBtn = input.previousElementSibling
    const plusBtn = input.nextElementSibling

    if (minusBtn && plusBtn) {
      minusBtn.addEventListener("click", () => {
        if (input.value > 1) {
          input.value = Number.parseInt(input.value) - 1
        }
      })

      plusBtn.addEventListener("click", () => {
        input.value = Number.parseInt(input.value) + 1
      })
    }
  })

  // Variant selectors
  const variantRadios = document.querySelectorAll('input[type="radio"][name^="options"]')
  variantRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      // This would typically trigger a variant price update via AJAX
      // For a full implementation, you'd need to add variant selection logic
    })
  })

  // FAQ accordion functionality
  const faqQuestions = document.querySelectorAll(".faq-question")

  faqQuestions.forEach((question) => {
    question.addEventListener("click", function () {
      const answer = this.nextElementSibling
      const icon = this.querySelector("svg")

      // Toggle this answer
      answer.classList.toggle("hidden")

      // Rotate icon
      if (answer.classList.contains("hidden")) {
        icon.classList.remove("rotate-180")
      } else {
        icon.classList.add("rotate-180")
      }
    })
  })

  // Add to cart functionality for mobile
  setupAjaxCart()

  // Filter highlighting for collection pages
  const urlParams = new URLSearchParams(window.location.search)
  const activeFilter = urlParams.get("filter")
  const filterLinks = document.querySelectorAll(".filter-link")
  const clearFilterBtn = document.querySelector(".clear-filter")

  if (activeFilter) {
    // Show clear button if a filter is active
    if (clearFilterBtn) {
      clearFilterBtn.classList.remove("hidden")
    }

    // Highlight the active filter
    filterLinks.forEach((link) => {
      const linkFilter = link.getAttribute("data-filter")
      if (linkFilter && linkFilter.toLowerCase() === activeFilter.toLowerCase()) {
        link.classList.remove("bg-zinc-800")
        link.classList.add("bg-blue-600")
      }
    })
  }
})

function setupAjaxCart() {
  // Get all add to cart forms
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]')

  // Handle form submissions
  addToCartForms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault()
      addToCartAjax(form)
    })
  })

  // Also handle direct add to cart buttons (for mobile)
  const addToCartButtons = document.querySelectorAll('.js-add-to-cart, button[type="submit"][name="add"]')

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      // Only prevent default if it's not inside a form
      // This ensures the button works both as a form submit trigger and as a direct add button
      if (!button.closest('form[action="/cart/add"]')) {
        e.preventDefault()

        // Find the closest form or get the product ID from the button
        const form = button.closest("form")
        if (form) {
          addToCartAjax(form)
        } else {
          // If no form, try to get product ID from button attributes
          const variantId = button.getAttribute("data-variant-id") || button.getAttribute("data-id")
          if (variantId) {
            addToCartByVariantId(variantId)
          }
        }
      }
    })
  })
}

function addToCartAjax(form) {
  const formData = new FormData(form)

  // Add to cart via AJAX
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }
      return response.json()
    })
    .then((data) => {
      // Refresh cart drawer content
      refreshCartDrawer()

      // Open cart drawer
      openCartDrawer()
    })
    .catch((error) => {
      console.error("Error:", error)
      // Fallback to traditional form submission if AJAX fails
      form.submit()
    })
}

function addToCartByVariantId(variantId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      refreshCartDrawer()
      openCartDrawer()
    })
    .catch((error) => {
      console.error("Error:", error)
      // Fallback - redirect to cart page
      window.location.href = "/cart"
    })
}

function openCartDrawer() {
  const cartDrawer = document.getElementById("cart-drawer")
  const cartOverlay = document.getElementById("cart-overlay") || document.getElementById("overlay")

  if (cartDrawer && cartOverlay) {
    cartDrawer.classList.remove("translate-x-full")
    cartOverlay.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }
}

function refreshCartDrawer() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Update cart count
      updateCartCount(cart.item_count)

      // Refresh cart drawer content if it exists
      const cartDrawerContent = document.getElementById("cart-drawer-content")
      if (cartDrawerContent) {
        if (cart.item_count > 0) {
          let cartContent = ""

          // Generate cart items HTML
          cart.items.forEach((item, index) => {
            const imageUrl = item.image ? item.image : "/placeholder.svg?height=100&width=100"

            cartContent += `
              <div class="flex items-center space-x-4">
                <div class="relative h-16 w-16 flex-shrink-0 rounded-md overflow-hidden">
                  <img src="${imageUrl}" alt="${item.title}" class="absolute inset-0 w-full h-full object-cover">
                </div>
                <div class="flex-1 min-w-0">
                  <h4 class="text-sm font-medium text-white truncate">
                    ${item.product_title}
                    ${item.variant_title && item.variant_title !== "Default Title" ? `<span>(${item.variant_title})</span>` : ""}
                  </h4>
                  <p class="text-sm text-gray-400">
                    ${formatMoney(item.price)} × ${item.quantity}
                  </p>
                </div>
                <div class="flex items-center">
                  <p class="text-sm font-medium text-white">${formatMoney(item.line_price)}</p>
                  <a href="/cart/change?line=${index + 1}&quantity=0" class="ml-4 text-gray-400 hover:text-white js-remove-from-cart" data-line="${index + 1}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    <span class="sr-only">Remove</span>
                  </a>
                </div>
              </div>
            `
          })

          // Update cart drawer content
          cartDrawerContent.innerHTML = `
            <div class="space-y-6">
              ${cartContent}
            </div>
          `

          // Make sure the footer with checkout button is visible
          const footerElement = document.getElementById("cart-drawer-footer")
          if (footerElement) {
            footerElement.style.display = "block"

            // Update subtotal
            const subtotalElement = document.querySelector("#cart-drawer-footer p:last-of-type")
            if (subtotalElement) {
              subtotalElement.textContent = formatMoney(cart.total_price)
            }
          }
        } else {
          // Empty cart
          cartDrawerContent.innerHTML = `
            <div class="flex flex-col items-center justify-center h-[50vh]">
              <p class="text-gray-400">Your cart is empty</p>
              <a href="/collections/all" class="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-md transition-colors">
                Start Shopping
              </a>
            </div>
          `

          // Hide the footer when cart is empty
          const footerElement = document.getElementById("cart-drawer-footer")
          if (footerElement) {
            footerElement.style.display = "none"
          }
        }
      }
    })
}

function updateCartCount(count) {
  const cartButton = document.getElementById("cart-button")
  if (cartButton) {
    if (count > 0) {
      cartButton.textContent = `Cart (${count})`
    } else {
      cartButton.textContent = "Cart"
    }
  }
}

function formatMoney(cents) {
  if (typeof cents === "string") {
    cents = Number.parseInt(cents)
  }
  const value = (cents / 100).toFixed(2)
  return "$" + value
}
